exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".area[data-v-1b1eaf86]{margin:35% 16px 0 27px}.loading[data-v-1b1eaf86]{position:absolute;padding-top:60%;padding-left:40%}.area .title[data-v-1b1eaf86]{font-size:18px;font-weight:600}.area .line[data-v-1b1eaf86]{margin:30px 20px 0 0;padding:6px 10px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;background:#f9f9f9;line-height:26px;font-size:14px}.area .bottom[data-v-1b1eaf86]{margin:16px;position:absolute;right:10px;left:10px;bottom:10px}.van-dialog__confirm[data-v-1b1eaf86]:active,[data-v-1b1eaf86] .van-dialog__confirm{color:#33c0b2}.dialog-content[data-v-1b1eaf86]{margin:9px 12px 10px;font-size:14px}.dialog-content .text[data-v-1b1eaf86]{margin-bottom:14px;line-height:22px}.dialog-content .dialog-line[data-v-1b1eaf86]{line-height:40px;border-bottom:1px solid;border-bottom-color:#e2e2e2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b1eaf86","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/area/areaSelect.vue
// module id = 398
// module chunks = 1